import * as React from "react";
import type { SVGProps } from "react";
const TwitterXBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={15}
    fill="none"
    viewBox="0 0 17 15"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.995 0h2.53L9.997 6.318l6.503 8.597h-5.092L7.421 9.7l-4.564 5.213H.326l5.912-6.757L0 0h5.22l3.605 4.766zm-.888 13.4h1.402L4.459 1.435H2.955z"
    />
  </svg>
);
export default TwitterXBlack;
